import script from "./ToggleAnimation.vue?vue&type=script&lang=js"
export * from "./ToggleAnimation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__